import type { CareerStage } from "@/lib/questions";
import { getJobTypeLabel } from "@/lib/jobTypes";

// 第二新卒バッジは新卒（オレンジ系）と中途（青系）の中間色（ふじ色系）。
// docs/plans/mockups/20260430_practice_select_target_audience.html 由来の配色を踏襲する。
export const CAREER_BADGE_STYLE: Record<
  CareerStage,
  { bg: string; text: string; label: string }
> = {
  new_grad:        { bg: "bg-[#FEF3F0]", text: "text-[#C2683E]", label: "新卒" },
  second_new_grad: { bg: "bg-[#FCEFFB]", text: "text-[#A21CAF]", label: "中途（第二新卒）" },
  mid_career:      { bg: "bg-[#EBF5FF]", text: "text-[#2563EB]", label: "中途" },
  high_school:     { bg: "bg-[#EEFDF8]", text: "text-[#047857]", label: "高校生" },
  all:             { bg: "bg-surface-container-low", text: "text-outline", label: "共通" },
};

export function CareerBadge({ stage }: { stage: CareerStage }) {
  const style = CAREER_BADGE_STYLE[stage];
  return (
    <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${style.bg} ${style.text}`}>
      {style.label}
    </span>
  );
}

// 大学が登録した練習用質問の印（#1861）。通常の質問と見分けるため赤で出す。
export function UniversityBadge() {
  return (
    <span className="text-[11px] font-bold px-2 py-0.5 rounded bg-error text-white">
      大学専用
    </span>
  );
}

// 中途バッジ（#EBF5FF/#2563EB）および「技術課題」カテゴリバッジ（#EFF6FF/#3B82F6、score-utils.categoryBadgeClass 由来）と
// 衝突しないティール色を使う。エンジニア × 技術課題 質問で隣り合っても識別できるようにする。
export function JobTypeBadge({ jobKey }: { jobKey: string }) {
  return (
    <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-[#ECFEFF] text-[#0E7490]">
      {getJobTypeLabel(jobKey)}
    </span>
  );
}
